import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FileUpload, FormButtons, FormRow, Loading } from '../controls';

function buildDefaultValues(faq) {
  return {
    faqName: faq.faqName || '',
    faqDescription: faq.faqDescription || '',
    priority: faq.priority || 0,
  };
}

export function FAQForm({
  faq,
  onFileUpload,
  loading,
  handleSave,
  onFileDelete,
}) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(faq),
    mode: 'onSubmit',
  });

  const faqId = faq?.faqId;

  useEffect(() => {
    reset(buildDefaultValues(faq));
  }, [faqId, reset]);

  const fileList = [];

  if (faq.photoURL) {
    fileList.push({
      uid: '-1',
      name: faq.faqPhoto,
      url: faq.photoURL,
      status: 'done',
    });
  }

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <div className="flex flex-col gap-4 sm:flex-row">
        <div className="min-w-0 flex-1">
          <FormRow label="FAQ Name" error={errors.faqName?.message}>
            <input
              type="text"
              placeholder="Name"
              {...register('faqName', { required: 'FAQ name is required' })}
            />
          </FormRow>
          <FormRow>
            <Controller
              name="priority"
              control={control}
              render={({ field }) => (
                <label className="inline-flex w-fit cursor-pointer items-center gap-2">
                  <input
                    type="checkbox"
                    className="h-4 w-4 cursor-pointer accent-[var(--primary)]"
                    checked={Number(field.value) === 1}
                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                  />
                  <span className="text-[0.9rem] font-bold uppercase tracking-[0.5px] text-[var(--foreground)]">
                    Full Screen
                  </span>
                </label>
              )}
            />
          </FormRow>
        </div>
        <div className="w-full shrink-0 sm:w-48 md:w-56">
          <FormRow>
            <div className="w-full">
              <FileUpload
                fileList={fileList}
                onFileUpload={onFileUpload}
                onFileDelete={onFileDelete}
              />
            </div>
          </FormRow>
        </div>
      </div>
      <FormRow label="Description" error={errors.faqDescription?.message}>
        <textarea
          placeholder="FAQ Description..."
          {...register('faqDescription', {
            required: 'Description is required',
          })}
        />
      </FormRow>
      {loading && <Loading />}
      <FormButtons title="FAQ" />
    </form>
  );
}
